import React from "react";

// Brand mark used in the navbar, footer, and (via /public/brand + the
// favicon/manifest files derived from it) browser tab + home screen icons.
// It's one 420x420 transparent PNG cropped from the source artwork, so it
// stays crisp at any retina density when scaled down by className/CSS —
// no separate 1x/2x/3x exports needed. object-contain keeps the aspect
// ratio intact (never stretched); pass className to control display size.
// Default size intentionally larger than plain text — the icon should read
// as the dominant brand mark at a glance, with "PartyBuddy" as a secondary
// label next to it (see Navbar.js), without growing the header's height.
function Logo({ className = "h-11 w-11" }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/brand/partybuddy-icon.png`}
      alt="PartyBuddy"
      width="44"
      height="44"
      className={`shrink-0 object-contain ${className}`}
    />
  );
}

export default Logo;
